import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/solaria360.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Solaria 360W All Black" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/SOLARIA360.js